//AdmitCardSeatPlan
import React, { useEffect } from 'react'
import { useState } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox, notification, Tabs } from 'antd'
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import { SelectClassConfig } from '../../../select/SelectClassConfig';
import { SelectSemesterYearByClass } from '../../../select/SelectSemesterYearByClass';
import { DownloadOutlined, SaveOutlined } from '@ant-design/icons';
import FileSaver from 'file-saver';
import axios from 'axios';

export default function AdmitCardSeatPlan (){

    const { Option } = Select;
    const [seatPlanAndAdmitCardForm] = Form.useForm();
    const fetchSemesterListByClassConfigId = useStoreActions((state) => state.exam.fetchSemesterListByClassConfigId);
    const semesterListByClassConfigIdArray = useStoreState((state) => state.exam.semesterListByClassConfigIdArray);
    const fetchAdmitCardPdf = useStoreActions((state) => state.exam.fetchAdmitCardPdf);
    const fetchSeatPlanPdf = useStoreActions((state) =>  state.exam.fetchSeatPlanPdf);
    const onChangeClassList = (val) => {
        fetchSemesterListByClassConfigId(val);        
    }

    const seatPlanAndAdmitCardDownload = (value) => {
        if(value.selectType == "admit"){
            let postdataAdmit:any = {
                startRoll : value.fromRoll,
                endRoll : value.toRoll,
                examConfigId : value.semesterYear,
                classConfigId : value.sectionList,
            }
            fetchAdmitCardPdf(postdataAdmit);
        }else{
            let postdataSeatPlan:any = {
                startRoll : value.fromRoll,
                endRoll : value.toRoll,
                examConfigId : value.semesterYear,
                classConfigId : value.sectionList,
            }
            fetchSeatPlanPdf(postdataSeatPlan);
        }
    }


    return(
        <>
            <Card title="Exam Admit Card and Seat Plan Download">
                <Row>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }} lg={{ span: 16, offset: 4 }} xl={{ span: 16, offset: 4 }}>
                        <Form
                            layout="vertical"
                            id="sessionInfo"
                            onFinish={seatPlanAndAdmitCardDownload}
                            form={seatPlanAndAdmitCardForm}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                                    <Form.Item
                                        name="sectionList"
                                        label="Section List"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select section" },
                                        ]}
                                    >
                                        <SelectClassConfig onChange={(e) => onChangeClassList(e)} />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                                    <Form.Item
                                        name="semesterYear"
                                        label="Exam List"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select semester" },
                                        ]}
                                    >
                                        <Select placeholder="Semester list" style={{ width: "100%" }}>
                                            {semesterListByClassConfigIdArray ? (
                                                    semesterListByClassConfigIdArray.map((type, idx) => (
                                                    <Option key={type.examConfigId} value={type.examConfigId}>
                                                        {type.examName}
                                                    </Option>
                                                    ))
                                                ) : (
                                                    <Option value="fetching">Fetching semester</Option>
                                                )}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                    <Form.Item
                                        name="fromRoll"
                                        label="From Roll"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write from roll" },
                                        ]}
                                    >
                                        <InputNumber placeholder="From roll" />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                    <Form.Item
                                        name="toRoll"
                                        label="To Roll"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write to roll" },
                                        ]}
                                    >
                                        <InputNumber placeholder="To roll" />
                                    </Form.Item>             
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                    <Form.Item
                                        name="selectType"
                                        label="Admit Card/Seat Plan"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select Admit Card/Seat Plan" },
                                        ]}
                                    >
                                        <Select placeholder="Select Admit Card/Seat Plan">
                                            <Option value="admit" key="1">Admit Card</Option>
                                            <Option value="seat" key="2">Seat Plan</Option>
                                        </Select>
                                    </Form.Item>             
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                                    <Button type="primary" htmlType="submit" icon={<DownloadOutlined />} className="float-right mt-0">Download</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </>
    )
}